// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { Shipment, shipmentSchema } from '@/shipment/api/types';
import { z } from 'zod';

/**
 * Schema for the get shipment response.
 */
const getShipmentResponseSchema = z.object({
  data: shipmentSchema,
  metadata: responseMetadataSchema,
});

/**
 * Fetches a single shipment by its key.
 *
 * @param shipmentKey - The unique key of the shipment to fetch
 * @returns The shipment details including serials
 * @throws Error if the request fails or validation fails
 */
export async function getShipment(shipmentKey: string): Promise<Shipment> {
  const url = `/v1/shipment/${shipmentKey}`;
  const response = await api.get(url);

  const { data } = await parseResponse(
    getShipmentResponseSchema,
    response.data,
    {
      schemaName: 'GetShipment',
      endpoint: url,
    }
  );
  return data;
}
